<template>
  <div>
    <b-row class="mt-4">
      <template v-for="(summaryNumber, idx) in summaryNumbers">
        <!-- <b-col
          :key="idx"
          v-if="summaryNumber.disabled"
          xs="12" sm="6" :md="mdSize()"
        > -->
        <b-col
          :key="idx"
          v-if="summaryNumber.name !='delivered'"
          xs="12" sm="6" :md="mdSize()"
        >
          <!-- <div v-if="summaryNumber.name =='delivered'"
              class="shadow bg-white rounded-lg px-4 py-3 mb-3"
            >
              <div class="text-gray-400 font-weight-bold text-uppercase">
                {{ summaryNumber.name }}
              </div>
              <div class="d-flex align-items-center justify-content-between mt-2">
                <div class="text-gray-500 font-weight-bold text-3xl">
                  {{ summaryNumber.items.length }}
                </div>
              </div>
          </div> -->
          <!-- <router-link v-else
            :to="`/dash/${idx.toLowerCase()}`"
          > -->
          <router-link
            :to="`/dash/${idx.toLowerCase()}`"
          >
            <div
              class="shadow bg-white rounded-lg px-4 py-3 mb-3"
            >
              <div class="text-gray-400 font-weight-bold text-uppercase">
                {{ summaryNumber.name }}
              </div>
              <div class="d-flex align-items-center justify-content-between mt-2">
                <div class="text-gray-500 font-weight-bold text-3xl">
                  {{ summaryNumber.items.length }}
                </div>
                <!-- <b-icon
                  :icon="summaryNumber.increase ? 'arrow-up' : 'arrow-down'"
                  :class="summaryNumber.increase ? 'text-green-500' : 'text-red-500'"
                  font-scale="2"
                ></b-icon> -->
              </div>
              <!-- <div class="d-flex justify-content-end">
                <div class="text-gray-400 text-xs text-right">
                  5% {{ summaryNumber.increase ? 'more' : 'less' }}<br/>than yesterday
                </div>
              </div> -->
            </div>
          </router-link>
        </b-col>
      </template>
    </b-row>
    <b-row class="mt-4" v-if="this.can('Analytics-Dashboard', 'read only')">
      <b-col sm="12" md="6" lg="9">
        <div class="shadow bg-white rounded-lg px-4 py-3 mb-3">
          <div class="text-gray-400 font-weight-bold text-uppercase">
            Revenue
          </div>
          <div class="text-gray-500 text-xs">
            Last 12 months
          </div>
          <div class="position-relative mt-3" style="width: 100%; height: 300px;">
            <canvas
              id="sales-chart"
            ></canvas>
          </div>
        </div>
      </b-col>
      <b-col sm="12" md="6" lg="3">
        <div class="shadow bg-white rounded-lg px-4 py-3 mb-3">
          <div class="text-gray-400 font-weight-bold text-uppercase">
            Shipments
          </div>
          <div class="text-gray-500 text-xs">
            Last 12 months
          </div>
          <div class="position-relative mt-3" style="width: 100%; height: 300px;">
            <canvas
              id="shipments-chart"
            ></canvas>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Chart from 'chart.js';
import * as d3 from 'd3';

export default {
  name: 'Dashboard',
  props: ['summaryNumbers'],
  methods: {
    mdSize() {
      return this.can('Analytics-Dashboard', 'read only') ? '2' : '6';
    },
  },
  mounted() {
    Chart.pluginService.register({
      beforeDraw(chart) {
        if (chart.config.options.elements.center) {
          // Get ctx from string
          const { ctx } = chart.chart;

          // Get options from the center object in options
          const centerConfig = chart.config.options.elements.center;
          const fontStyle = centerConfig.fontStyle || 'Arial';
          const txt = centerConfig.text;
          const color = centerConfig.color || '#000';
          const maxFontSize = centerConfig.maxFontSize || 75;
          const sidePadding = centerConfig.sidePadding || 20;
          const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
          // Start with a base font of 30px
          ctx.font = `30px ${fontStyle}`;

          // Get the width of the string and also the width of the element minus 10 to give it 5px
          // side padding
          const stringWidth = ctx.measureText(txt).width;
          const elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

          // Find out how much the font can grow in width.
          const widthRatio = elementWidth / stringWidth;
          const newFontSize = Math.floor(30 * widthRatio);
          const elementHeight = (chart.innerRadius * 2);

          // Pick a new font size so it will not be larger than the height of label.
          let fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize);
          let { minFontSize } = centerConfig;
          const lineHeight = centerConfig.lineHeight || 25;
          let wrapText = false;

          if (minFontSize === undefined) {
            minFontSize = 20;
          }

          if (minFontSize && fontSizeToUse < minFontSize) {
            fontSizeToUse = minFontSize;
            wrapText = true;
          }

          // Set font settings to draw it correctly.
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
          let centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
          ctx.font = `${fontSizeToUse}px ${fontStyle}`;
          ctx.fillStyle = color;

          if (!wrapText) {
            ctx.fillText(txt, centerX, centerY);
            return;
          }

          const words = txt.split(' ');
          let line = '';
          const lines = [];

          // Break words up into multiple lines if necessary
          for (let n = 0; n < words.length; n += 1) {
            const testLine = `${line + words[n]} `;
            const metrics = ctx.measureText(testLine);
            const testWidth = metrics.width;
            if (testWidth > elementWidth && n > 0) {
              lines.push(line);
              line = `${words[n]} `;
            } else {
              line = testLine;
            }
          }

          // Move the center up depending on line height and number of lines
          centerY -= (lines.length / 2) * lineHeight;

          for (let n = 0; n < lines.length; n += 1) {
            ctx.fillText(lines[n], centerX, centerY);
            centerY += lineHeight;
          }
          // Draw text in center
          ctx.fillText(line, centerX, centerY);
        }
      },
    });

    const ctx = document.getElementById('sales-chart').getContext('2d');
    const options0 = {
      type: 'bar',
      data: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
          {
            label: 'Barrel',
            data: [
              12065, 10076, 12546, 16525, 10318, 19280, 14649, 10622, 17055, 17454, 15582, 18113,
            ],
            backgroundColor: '#6cba94',
          },
          {
            label: 'Box',
            data: [
              13939, 16019, 16125, 15504, 15496, 10339, 12959, 11013, 12031, 16565, 16750, 15001,
            ],
            backgroundColor: '#89acd4',
          },
          {
            label: 'Vehicle',
            data: [
              15522, 12456, 11474, 12068, 18048, 19349, 10767, 18107, 16753, 17347, 19084, 19916,
            ],
            backgroundColor: '#747f8a',
          },
          {
            label: 'Other',
            data: [
              13051, 11224, 19910, 19399, 16674, 17587, 17844, 18119, 14695, 19349, 19513, 16938,
            ],
            backgroundColor: '#dce0e2',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        hover: {
          mode: 'nearest',
        },
        scales: {
          xAxes: [{
            stacked: true,
            gridLines: {
              display: false,
            },
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: (value) => `$${d3.format('~s')(value)}`,
            },
            gridLines: {
              tickMarkLength: 10,
              drawBorder: false,
            },
            stacked: true,
          }],
        },
        layout: {
          padding: {
            left: 0,
            right: 10,
            top: 0,
            bottom: 0,
          },
        },
        title: {
          display: false,
          text: 'Shipment Amounts',
        },
        legend: {
          position: 'bottom',
        },
      },
    };
    const doughnutData = [7, 19, 28, 6, 82, 70];
    const options1 = {
      type: 'doughnut',
      data: {
        labels: ['Puerto Rico', 'Jamaica', 'Haiti', 'Bermuda', 'Trinidad', 'Other'],
        datasets: [{
          label: '$',
          data: doughnutData,
          // backgroundColor: ['#e76c6c', '#fa9f7b', '#b5d6e0', '#ffdc7d', '#427ca1', '#b6bebf'],
          // backgroundColor: ['#f068c7', '#ff7700', '#00a700', '#9c5dc4', '#00c1d4', '#7f7f7f'],
          backgroundColor: ['#ed4955', '#fb8900', '#44a543', '#b576a3', '#69b9b2', '#b6bebf'],
          fill: false,
          pointHitRadius: 20,
        }],
      },
      options: {
        elements: {
          center: {
            text: doughnutData.reduce((a, b) => a + b, 0),
            color: 'rgb(107, 114, 128)', // Default is #000000
            fontStyle: 'Arial', // Default is Arial
            sidePadding: 40, // Default is 20 (as a percentage)
            minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
            lineHeight: 25, // Default is 25 (in px), used for when text wraps
          },
        },
        cutoutPercentage: 75,
        responsive: true,
        maintainAspectRatio: false,
        hover: {
          mode: 'nearest',
        },
        layout: {
          padding: {
            left: 0,
            right: 10,
            top: 0,
            bottom: 0,
          },
        },
        title: {
          display: false,
          text: 'Shipment Amounts',
        },
        legend: {
          position: 'bottom',
          align: 'start',
        },
      },
    };
    // eslint-disable-next-line no-unused-vars
    const shipmentChart = new Chart(ctx, options0);
    // eslint-disable-next-line no-unused-vars
    const doughnutChart = new Chart(
      document.getElementById('shipments-chart').getContext('2d'),
      options1,
    );
  },
};
</script>

<style scoped>

</style>
